module.exports = __webpack_public_path__ + "img/badge-most-appointment-gold.67892bc5.png";